<template>
    <a class="dropdown-item delete-btn" @click="onClickDelete" :id="deleteButtonId">
        Delete
    </a>
</template>

<script>

export default {
    name: "employeeDeleteComponent",
    props: ["userId", "employeeId"], // vue can read kebab props as camel cased vars    

    setup() {
    },

    data() {  
       
        var endpointToUse = location.protocol + "//" + window.location.host + "/api/employees/" + this.employeeId + "/" + '6m8geptupkijwghd7xkya6wbjkrqo1wwpuuhmzzuuqhqhovy2mclfumdkccg';
  
        return {
            endpoint: endpointToUse,
            deleteButtonId: "delete-btn-"+this.employeeId,
        };
    },

    validations() {  
    },

    computed: {     
    },

    methods: {
        onClickDelete: function () { 
         
            // Initialize alerts and toast notifications for displaying message  
            const toastError = Swal.mixin({          
                    toast: true,                
                    position: 'top-end', 
                    showConfirmButton: true, 
                });  
            const alertSuccess = Swal.mixin({                          
                    position: 'center', 
                    showConfirmButton: true, 
                    timer: 3000,
                    timerProgressBar: true,
                });
            const confirmDelete = Swal.mixin({                          
                    position: 'center', 
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it",
                    cancelButtonText: "Cancel",
                });
            const formData = {};
            
            // Show button spinner
            document.getElementById('delete-btn-'+this.employeeId).innerHTML  = '<i class="fa fa-circle-notch fa-spin"></i>';
            document.getElementById('delete-btn-'+this.employeeId).disabled  = true;                   

            confirmDelete.fire({
                title: "Are you sure?",
                text: "Clicking yes will delete the employee",
                icon: "warning",                    
            }).then((result) => {
                if (result.isConfirmed) {
                    // Add userID            
                    formData['userID'] = this.userId;
                    
                    // Remove the employee
                    this.deleteEmployee(formData, toastError, alertSuccess);
                }
            }); 

            // Show button spinner
            document.getElementById('delete-btn-'+this.employeeId).innerHTML  = 'Delete';
            document.getElementById('delete-btn-'+this.employeeId).disabled  = false;                   

    
        },


        deleteEmployee: function(formData, toastError, alertSuccess) {    
            
            // Call the update endpoint
            axios.delete(this.endpoint, { data: formData }) //delete doesn't support
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the bed object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            }); 
                            
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                                // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the bed object was deleted from the DB
                            this.formSuccess = true                          
                            alertSuccess.fire({
                                title: "Success!",
                                text: "The employee has been deleted.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/employees";
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'error', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        },

    },
};
</script>
